import Crud from './crud'
var crud = new Crud('order_products', 'chi tiết xe');

const state = {
    ...crud.state,
    selected: {TruckID: 0}
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};